angular.module('unica_survey.survey_services')

.factory('SurveyListService', function ($http, getBaseApiURL) {

	var surveyListService = {};

	surveyListService.list = function (eventId, limit, offset)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/survey/list/' + eventId,
			data: {
				limit: limit,
				offset: offset
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.surveys;
			}

		});
	};

	surveyListService.fullList = function ( eventId )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/survey/full-list/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.surveys;
			}

		});
	};

	surveyListService.get = function (surveyId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/survey/detail/' + surveyId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.survey;
			}

		});
	};

	return surveyListService;
});